<template>
  <fieldset class="flex items-center gap-2">
    <legend class="sr-only">Metrics range</legend>
    <span class="text-xs text-gray-500 dark:text-gray-400" aria-hidden="true">Metrics</span>
    <div class="isolate inline-flex rounded-md shadow-sm">
      <label
        v-for="(option, index) in options"
        :key="option"
        :title="RANGE_DESCRIPTIONS[option]"
        class="relative inline-flex cursor-pointer items-center bg-white px-2.5 py-1.5 text-xs font-medium text-gray-700 ring-1 ring-gray-300 ring-inset hover:bg-gray-50 focus-within:z-10 has-checked:bg-indigo-600 has-checked:text-white has-checked:ring-indigo-600 has-focus-visible:outline-2 has-focus-visible:outline-offset-2 has-focus-visible:outline-indigo-600 dark:bg-gray-800 dark:text-gray-100 dark:ring-white/10 dark:hover:bg-gray-700 dark:has-checked:bg-indigo-500 dark:has-checked:ring-indigo-500"
        :class="[
          index === 0 ? 'rounded-l-md' : '-ml-px',
          index === options.length - 1 ? 'rounded-r-md' : '',
        ]"
      >
        <input
          type="radio"
          name="monitoring-range"
          class="sr-only"
          :value="option"
          :aria-label="RANGE_DESCRIPTIONS[option]"
          :checked="option === modelValue"
          @change="emit('update:modelValue', option)"
        />
        {{ RANGE_LABELS[option] }}
      </label>
    </div>
  </fieldset>
</template>

<script setup lang="ts">
import type { MonitoringRange } from '@/api/runners';
import { RANGE_DESCRIPTIONS, RANGE_LABELS } from '@/lib/monitoring-format';

defineProps<{ modelValue: MonitoringRange; options: readonly MonitoringRange[] }>();

const emit = defineEmits<{
  (e: 'update:modelValue', value: MonitoringRange): void;
}>();
</script>
